import createTableStore from "ds/components/Table/store/useTableStore";

import { STACK_WORKSPACES_COLUMNS_STORAGE_KEY, STACK_WORKSPACES_COLUMN_CONFIG } from "./constants";

const useStackWorkspacesTableStore = createTableStore({
  storageKey: STACK_WORKSPACES_COLUMNS_STORAGE_KEY,
  config: STACK_WORKSPACES_COLUMN_CONFIG,
});

export default useStackWorkspacesTableStore;
